export default __webpack_public_path__ + "static/media/keyboard.55d666d8.svg";